import classNames from 'classnames'
import React, { FC, useState } from 'react'
import { useBreakpoint } from '../hooks/useBreakpoint'
import { Breakpoints } from '../utilities/breakpoints'
import { isNullOrWhiteSpace } from '../utilities/string'
import { Button } from './Button'
import { LoadMoreButton } from './LoadMoreButton'
import { PersonLink, PersonLinkProps } from './PersonLink'

export interface PersonListProps {
  additionalClassName?: string
  allButtonText?: string
  allButtonUrl?: string
  enableMoreButton?: boolean
  persons: PersonLinkProps[]
}

export const PersonList: FC<PersonListProps> = ({
  additionalClassName = '',
  allButtonText,
  allButtonUrl,
  enableMoreButton,
  persons,
}) => {
  const [numItemsPerPage, setNumItemsPerPage] = useState<number>(8)
  const [numItemsToDisplay, setNumItemsToDisplay] = useState<number>(
    enableMoreButton ? numItemsPerPage : persons.length
  )

  useBreakpoint(Breakpoints.tb, above => {
    if (above) {
      setNumItemsPerPage(20)
    } else {
      setNumItemsPerPage(8)
    }
  })

  useBreakpoint(Breakpoints.sm, above => {
    if (above) {
      setNumItemsPerPage(15)
    } else {
      setNumItemsPerPage(20)
    }
  })

  useBreakpoint(Breakpoints.md, above => {
    if (above) {
      setNumItemsPerPage(12)
    } else {
      setNumItemsPerPage(15)
    }
  })

  useBreakpoint(Breakpoints.xl, above => {
    if (above) {
      setNumItemsPerPage(15)
    } else {
      setNumItemsPerPage(12)
    }
  })

  return (
    <div
      className={classNames(
        'col-span-full flex flex-col',
        'sm:col-start-2 sm:col-span-4 sm:-mx-30',
        'md:col-start-1 md:col-span-full md:mx-0',
        'lg:col-start-2 lg:col-span-6 lg:-mx-30',
        'xl:col-start-2 xl:col-span-8 xl:mx-0',
        'xxl:col-start-3 xxl:col-span-10',
        additionalClassName
      )}
    >
      <div
        className={classNames(
          'mx-auto grid grid-cols-mobile gap-x-30 gap-y-30',
          'tb:grid-cols-tb',
          'sm:grid-cols-people-sm sm:gap-x-people-sm',
          'md:grid-cols-people-md md:gap-x-people-md',
          'lg:grid-cols-people-lg lg:gap-x-people-lg ',
          'xl:grid-cols-people-xl xl:gap-x-people-xl',
          'xxl:grid-cols-people-xxl xxl:gap-x-people-xxl'
        )}
      >
        {!!persons?.length &&
          persons
            .slice(0, enableMoreButton ? numItemsToDisplay : undefined)
            .map((person, i) => <PersonLink key={i} {...person} />)}
      </div>

      {enableMoreButton && (
        <LoadMoreButton
          additionalClassName="mt-45 tb:mt-30 md:mt-60 lg:mt-45 xl:mt-60"
          currentNumItems={numItemsToDisplay}
          maxItems={persons.length}
          numItemsPerPage={numItemsPerPage}
          onLoadMore={setNumItemsToDisplay}
        />
      )}

      {!isNullOrWhiteSpace(allButtonUrl) && !isNullOrWhiteSpace(allButtonText) && (
        <footer className="text-center mt-45 tb:mt-30 md:mt-60 lg:mt-45 xl:mt-60">
          <Button url={allButtonUrl}>{allButtonText}</Button>
        </footer>
      )}
    </div>
  )
}
